/**
 * Execute Complete Course Migration
 * This script triggers the full legacy course migration process
 */

import { CourseMigrationService } from '@/services/CourseMigrationService';

export const executeCompleteMigration = async () => {
  console.log('🚀 EXECUTING COMPLETE COURSE MIGRATION');
  console.log('================================================');
  
  try {
    // Phase 1: Start Migration
    console.log('📋 Phase 1: Initiating bulk migration process...');
    const results = await CourseMigrationService.migrateAllCourses();
    
    // Phase 2: Report Results
    console.log('\n📊 Phase 2: Migration Results');
    console.log('================================================');
    console.log(`✅ Total Processed: ${results.total}`);
    console.log(`🎯 Successfully Migrated: ${results.successful}`);
    console.log(`❌ Failed: ${results.failed}`);
    console.log(`📈 Success Rate: ${Math.round((results.successful / results.total) * 100)}%`);
    
    if (results.errors.length > 0) {
      console.log('\n⚠️  Migration Errors:');
      results.errors.forEach((error, index) => {
        console.log(`   ${index + 1}. ${error}`);
      });
    }
    
    // Phase 3: Get Final Stats
    console.log('\n📈 Phase 3: Getting final statistics...');
    const finalStats = await CourseMigrationService.getCourseStats();
    console.log(`📚 Total Courses in Database: ${finalStats.totalCourses}`);
    console.log(`📖 Total Modules: ${finalStats.totalModules}`);
    console.log('📊 Courses by Category:');
    
    Object.entries(finalStats.coursesByCategory)
      .sort(([,a], [,b]) => b - a)
      .forEach(([category, count]) => {
        console.log(`   ${category}: ${count} courses`);
      });
    
    console.log('\n🎉 MIGRATION EXECUTION COMPLETE!');
    console.log('================================================');
    
    return {
      migrationResults: results,
      finalStats: finalStats,
      success: results.successful > 0
    };
    
  } catch (error) {
    console.error('❌ Migration execution failed:', error);
    throw error;
  }
};

// Auto-execute if running directly
if (typeof window !== 'undefined') {
  console.log('🔥 Auto-executing migration...');
  executeCompleteMigration()
    .then(() => console.log('✅ Auto-execution completed'))
    .catch(err => console.error('❌ Auto-execution failed:', err));
}